// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel_controller-module__button--3x-qk{position:absolute;border:0;width:45px;font-size:24px;color:#616161;cursor:pointer}.carousel_controller-module__right--fJOcw{right:0;top:0;bottom:0;background:-webkit-gradient(linear, left top, right top, color-stop(0%, rgba(255,255,255,0)), color-stop(80%, #fff))}.carousel_controller-module__left--1c4iy{left:0;top:0;bottom:0;background:-webkit-gradient(linear, right top, left top, color-stop(80%, #fff), color-stop(0%, rgba(255,255,255,0)))}\n", ""]);
// Exports
exports.locals = {
	"button": "carousel_controller-module__button--3x-qk",
	"right": "carousel_controller-module__right--fJOcw",
	"left": "carousel_controller-module__left--1c4iy"
};
module.exports = exports;
